function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "A__53");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.68463,79.11316a9.159,9.159,0,0,0,.1239,13.07831,9.159,9.159,0,0,0,13.07831.1239L55.47668,57.72552c6.41791-6.41784,9.4571-6.46093,15.01819-6.43945,6.55268.02161,11.9682-1.234,17.82569-7.09149a22.7915,22.7915,0,0,0,6.1-21.25287c-.23712-1.04541-1.09393-1.27716-1.8537-.51733L79.08435,35.9068a3.64335,3.64335,0,0,1-3.18463.85687l-7.95905-2.12854a3.468,3.468,0,0,1-1.55731-1.01849,3.468,3.468,0,0,1-1.01849-1.55731l-2.12854-7.95905a3.64335,3.64335,0,0,1,.85687-3.18463L77.57562,7.43317c.75983-.75977.52808-1.61658-.51733-1.8537a22.7915,22.7915,0,0,0-21.25287,6.1c-5.85748,5.85749-7.1131,11.273-7.09149,17.82569.02148,5.56109-.02161,8.60028-6.43945,15.01819Z"
});

var SvgWorkWrench = function SvgWorkWrench(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef
  }, props), React.createElement("g", null, React.createElement("g", {
    transform: "translate(50 50) scale(0.69 0.69) rotate(0) translate(-50 -50)",
    style: {
      fill: "#000000"
    }
  }, React.createElement("svg", _extends({
    fill: "#000000",
    "data-name": "Layer 1",
    viewBox: "0 0 100 100",
    x: "0px",
    y: "0px",
    ref: svgRef
  }, props), _ref2, _ref3))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWorkWrench, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/work-wrench.2de4ccd0.svg";
export { ForwardRef as ReactComponent };